import React, { useState } from "react";
import useFlowStatus from "../../../../hooks/useFlowStatus";
import { IoCopyOutline } from "react-icons/io5";
import styles from "./flowInfo.module.css";
import Spinner from "../../../Spinner";

const FlowInfo = ({ flowState }) => {
  const { isPublished, isLoading } = useFlowStatus(flowState._id);
  const [copyAnimation, setCopyAnimation] = useState(false);

  const handleCopyButtonClick = function (text) {
    // copy to clipboard
    navigator.clipboard.writeText(text);
    setCopyAnimation(true);
    setTimeout(() => {
      setCopyAnimation(false);
    }, 500);
  };

  const getFlowPublicLink = function () {
    if (isLoading !== undefined && isLoading) {
      return (
        <div>
          <Spinner spinning={isLoading} />
        </div>
      );
    }

    if (!isPublished) {
      return (
        <div>
          <span className={styles.no_link_text}>
            No link yet. Please publish your flow to got a link.
          </span>
        </div>
      );
    }

    let link = "";

    switch (flowState.app) {
      case "web-app":
        if (process.env.REACT_APP_STAGE === "prod") {
          link = `https://webapp.alloreview.com/${flowState.name}`;
          return (
            <div className={styles.link_container}>
              <a href={link} target="_blank" className={styles.link}>
                {link}
              </a>
              <span
                className={`${styles.copy_icon} ${
                  copyAnimation ? styles.copy_icon_animation : ""
                }`}
                onClick={() => handleCopyButtonClick(link)}
              >
                <IoCopyOutline />
              </span>
            </div>
          );
        }
        link = `https://d1w7q87m24bysy.cloudfront.net/${flowState.name}`;
        return (
          <div className={styles.link_container}>
            <a href={link} target="_blank" className={styles.link}>
              {link}
            </a>
            <span
              className={`${styles.copy_icon} ${
                copyAnimation ? styles.copy_icon_animation : ""
              }`}
              onClick={() => handleCopyButtonClick(link)}
            >
              <IoCopyOutline />
            </span>
          </div>
        );

      case "call-bot":
        if (process.env.REACT_APP_STAGE === "prod") {
          link = `https://callbot.allobrain.com/alloBot/${flowState.brand}/${flowState.name}`;
          return (
            <div className={styles.link_container}>
              <span className={styles.link}>{link}</span>
              <span
                className={`${styles.copy_icon} ${
                  copyAnimation ? styles.copy_icon_animation : ""
                }`}
                onClick={() => handleCopyButtonClick(link)}
              >
                <IoCopyOutline />
              </span>
            </div>
          );
        }

        link = `https://callbot.allobrain.com/dev/alloBot/${flowState.brand}/${flowState.name}`;

        return (
          <div className={styles.link_container}>
            <span className={styles.link}>{link}</span>
            <span
              className={`${styles.copy_icon} ${
                copyAnimation ? styles.copy_icon_animation : ""
              }`}
              onClick={() => handleCopyButtonClick(link)}
            >
              <IoCopyOutline />
            </span>
          </div>
        );

      default:
        return (
          <div>
            <span className={styles.no_link_text}>
              Incompatible app type. No link available.
            </span>
          </div>
        );
    }
  };

  return (
    <div>
      <div className={styles.info_line}>
        <span>Status: </span>
        {isLoading !== undefined && isLoading ? (
          <Spinner spinning={isLoading} />
        ) : (
          <span
            className={`${
              flowState.isSynchronizedWithPublishedConfig
                ? styles.synch_status
                : isPublished
                ? styles.published_status
                : styles.not_published_status
            }`}
          >
            {flowState.isSynchronizedWithPublishedConfig
              ? "Synchronized"
              : isPublished
              ? "Not synchronized"
              : "Not published"}
          </span>
        )}
      </div>

      <span className={styles.separator} />

      <div className={styles.info_line}>
        <span>Created by: </span>
        <span>
          {flowState.createdBy ? flowState.createdBy.toUpperCase() : "-"}
        </span>
      </div>
      <div className={styles.info_line}>
        <span>Created at: </span>
        <span>
          {flowState.createdAt
            ? new Date(flowState.createdAt * 1000).toLocaleString()
            : "-"}
        </span>
      </div>

      <div className={styles.info_line}>
        <span>Updated by: </span>
        <span>
          {flowState.updatedBy ? flowState.updatedBy.toUpperCase() : "-"}
        </span>
      </div>
      <div className={styles.info_line}>
        <span>Updated at: </span>
        <span>
          {flowState.updatedAt
            ? new Date(flowState.updatedAt * 1000).toLocaleString()
            : "-"}
        </span>
      </div>

      <span className={styles.separator} />

      <div>{getFlowPublicLink()}</div>
    </div>
  );
};

export default FlowInfo;
